"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NuiLogger = exports.NuiLogLevel = void 0;
var _config = _interopRequireDefault(require("../config"));
var _logProvider = require("../logProvider");
var _NuiStream = require("../NuiStream");
var _NuiTransport = require("../NuiTransport");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NuiLogLevel = exports.NuiLogLevel = Object.freeze({
  INFO: 'info',
  ERROR: 'error',
  WARN: 'warn',
  TRACE: 'trace',
  DEBUG: 'debug'
});
var NuiLogger = exports.NuiLogger = /*#__PURE__*/function () {
  /**
   * Create an NuiLogger.
   *
   * @param {Object} meta - The default metadata object for the logger.
   * The logger will add and populate these fields by default for every log record,
   * unless overridden while logging: `logger.log({ defaultMeta: overriddenValue })`.
   */
  function NuiLogger(meta) {
    _classCallCheck(this, NuiLogger);
    this.level = _config.default.nui.log.level;
    this.fields = _objectSpread(_objectSpread({}, meta), {}, {
      data_version: 2,
      datacenter_location: process.env.DATACENTER,
      name: _config.default.nui.baseUrl ? "".concat(_config.default.nui.baseUrl.replace('/', '').replace('/', '-')) : 'NUI'
    });
    var _makeLogger = (0, _logProvider.makeLogger)({
        level: this.level,
        defaultMeta: this.fields,
        useFormat: true
      }),
      streams = _makeLogger.streams,
      logger = _makeLogger.logger;
    this.streams = streams;
    this.logger = logger;
  }
  _createClass(NuiLogger, [{
    key: "getLevelFn",
    value: function getLevelFn(level) {
      var _this$logger;
      var loggerFn = (_this$logger = this.logger) === null || _this$logger === void 0 ? void 0 : _this$logger[level];
      if (typeof loggerFn !== 'function') {
        throw new Error("Unsupported log level: ".concat(level));
      }
      return loggerFn;
    }

    // use metadata values
    // for name, data_version, and datacenter_location
    // coming from the record, instead of the
    // ones configure when logger was created.
  }, {
    key: "reconfigure",
    value: function reconfigure() {
      var _record$name, _record$name$trim, _record$datacenter_lo, _record$datacenter_lo2;
      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (record !== null && record !== void 0 && (_record$name = record.name) !== null && _record$name !== void 0 && (_record$name$trim = _record$name.trim) !== null && _record$name$trim !== void 0 && _record$name$trim.call(_record$name) || record !== null && record !== void 0 && record.data_version || record !== null && record !== void 0 && (_record$datacenter_lo = record.datacenter_location) !== null && _record$datacenter_lo !== void 0 && (_record$datacenter_lo2 = _record$datacenter_lo.trim) !== null && _record$datacenter_lo2 !== void 0 && _record$datacenter_lo2.call(_record$datacenter_lo)) {
        this.logger.configure({
          level: this.level,
          transports: this.streams,
          defaultMeta: _objectSpread(_objectSpread({}, this.fields), {}, {
            name: record.name || this.fields.name,
            data_version: record.data_version || this.fields.data_version,
            datacenter_location: record.datacenter_location || this.fields.datacenter_location
          })
        });
      }
    }
  }, {
    key: "info",
    value: function info(record) {
      this.reconfigure(record);
      return this.logger.info(typeof record === 'string' ? record : _objectSpread(_objectSpread({}, record), {}, {
        message: (record === null || record === void 0 ? void 0 : record.message) || ' ',
        callStack: new Error().stack
      }));
    }
  }, {
    key: "_emit",
    value: function _emit(record) {
      return this.info(record);
    }
  }, {
    key: "error",
    value: function error(record) {
      this.reconfigure(record);
      return this.logger.error(typeof record === 'string' ? record : _objectSpread(_objectSpread({}, record), {}, {
        message: (record === null || record === void 0 ? void 0 : record.message) || ' ',
        callStack: new Error().stack
      }));
    }
  }, {
    key: "fatal",
    value: function fatal(record) {
      return this.error(record);
    }
  }, {
    key: "log",
    value: function log(level, record) {
      this.reconfigure(record);
      return this.getLevelFn(level)(typeof record === 'string' ? record : _objectSpread(_objectSpread({}, record), {}, {
        message: (record === null || record === void 0 ? void 0 : record.message) || ' ',
        callStack: new Error().stack
      }));
    }
  }, {
    key: "warn",
    value: function warn(record) {
      return this.log('warn', record);
    }
  }, {
    key: "trace",
    value: function trace(record) {
      return this.log('trace', record);
    }
  }, {
    key: "debug",
    value: function debug(record) {
      return this.log('debug', record);
    }
  }, {
    key: "metric",
    value: function metric(record) {
      var level = (record === null || record === void 0 ? void 0 : record.type) || 'info';
      var loggerFn = this.getLevelFn(level);
      this.reconfigure(record);
      return loggerFn(typeof record === 'string' ? {
        description: record,
        type: 'metric',
        message: ' ',
        callStack: new Error().stack
      } : _objectSpread(_objectSpread({}, record), {}, {
        type: 'metric',
        message: (record === null || record === void 0 ? void 0 : record.message) || ' ',
        callStack: new Error().stack
      }));
    }
  }, {
    key: "addStream",
    value: function addStream(options) {
      if (!options.stream) {
        throw new Error('addStream options should have a stream.');
      }
      var newStream = new _NuiTransport.NuiTransport(_objectSpread(_objectSpread({}, options), {}, {
        stream: new _NuiStream.NuiStream(options.stream)
      }));
      this.streams.push(newStream);
      this.logger.add(newStream);
    }
  }]);
  return NuiLogger;
}();
/** A new instance of NuiLogger */
var _default = exports.default = new NuiLogger();